/* eslint-disable import/no-anonymous-default-export */
import {} from "../../types";

export default (state, action) => {
    switch (action.type) {
        default:
            return state;
    }
};
